import { render, staticRenderFns } from "./camp_tab_component.vue?vue&type=template&id=78d0a921&scoped=true&"
import script from "./camp_tab_component.vue?vue&type=script&lang=js&"
export * from "./camp_tab_component.vue?vue&type=script&lang=js&"
import style0 from "./camp_tab_component.vue?vue&type=style&index=0&id=78d0a921&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d0a921",
  null
  
)

export default component.exports